// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Se2AM","rightAdornment":"Header_rightAdornment__2oBGi"};